import useProperties from '@/composables/property/property';

export default function useUpdateProperty() {
  const { updateProperties } = useProperties();

  return { properties: updateProperties };
}
